module.exports = new __parcel__URL__("plus-mask.26076cf9.svg").toString();